var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomizeEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 1.77778V0H4.44444V1.77778H11.5556V0H13.3333V1.77778H14.2222C15.2041 1.77778 16 2.57372 16 3.55556V14.2222C16 15.2041 15.2041 16 14.2222 16H1.77778C0.795938 16 0 15.2041 0 14.2222V3.55556C0 2.57372 0.795938 1.77778 1.77778 1.77778H2.66667ZM5 10.5L5.5 10L6.66667 10.2985L11.3715 5.59368L12.6285 6.85076L6.66667 12L5 10.5Z",
    fill: "#ACBED2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizeEvent);
export default __webpack_public_path__ + "static/media/CustomizeEvent.396b54f3a73ef97d0c75ef3041588111.svg";
export { ForwardRef as ReactComponent };